import React from 'react'
import { RoomCard } from './RoomCard.js'
import { RoomModel } from '../../common/models/RoomModel.js'
import { View } from '../view.js'

export interface RoomListProps {
    rooms: RoomModel[]
    view?: View
}

export function RoomList(props: RoomListProps) {
    const { rooms, view } = props

    if (rooms.length === 0) {
        return (
            <div className="px-6 pb-16">
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-gray-700 text-center">
                    <p>No rooms available</p>
                </div>
            </div>
        )
    }

    return (
        <div className="px-6 pb-6 items-center size-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {rooms.map(room => (
                    <RoomCard key={room.id} room={room} />
                ))}
            </div>
        </div>
    )
}
